import * as React from "react";

const CopyLink: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.485 10.242" fill="currentColor">
            <path
                fill="#75B8C8"
                d="M3.797 2.201c1.151-1.169 3.068-1.169 4.238 0 1.113 1.113 1.155 2.895.145 4.083l-.124.143a.375.375 0 0 1-.567-.49l.126-.145a2.245 2.245 0 0 0-.11-3.059 2.242 2.242 0 0 0-3.176 0L1.41 5.651a2.251 2.251 0 0 0 3.183 3.183l.53-.53a.372.372 0 0 1 .53 0 .372.372 0 0 1 0 .53l-.53.53a3 3 0 0 1-4.243 0C-.293 8.192-.293 6.272.879 5.12l2.918-2.92Zm6.87 5.84c-1.15 1.17-3.047 1.17-4.217 0a3.018 3.018 0 0 1-.166-4.082l.145-.143a.375.375 0 0 1 .568.49l-.127.145a2.245 2.245 0 0 0 .11 3.059c.877.879 2.3.879 3.176 0l2.92-2.918a2.25 2.25 0 1 0-3.183-3.183l-.53.53a.372.372 0 0 1-.529 0c-.148-.167-.148-.382 0-.53l.53-.53a3 3 0 0 1 4.242 0 2.974 2.974 0 0 1 0 4.221l-2.94 2.942Z"
            />
        </svg>
    );
};

export default React.memo(CopyLink);
